import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Container, Drawer, IconButton, Dialog, DialogContent, Card, CardMedia, Grid, CardContent, CardActions } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
// import Footer from './Footer';
import CourseRecommendation from './CourseRecommendation';
import { Star, Build, Flight, School } from '@mui/icons-material';
import { Home as HomeIcon, Settings as SettingsIcon, Cloud as CloudIcon, Business as BusinessIcon } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close'
import DroneshalaVendorForm from './DroneshlaForm';
// Import the image for the background section
// import drone from '../Image/DRONE-PLANET-Image (1).png';

const Droneshala = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openCourseRecommendation, setOpenCourseRecommendation] = useState(false);

  useEffect(() => {
    setOpenCourseRecommendation(true); // Opens the dialog as soon as the page loads
  }, []);
  
  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleDialogClose = () => {
    setOpenCourseRecommendation(false); // Close the CourseRecommendation dialog
  };

  return (
    <>
      <div style={{ backgroundColor: 'white' }}>
        {/* Navbar */}
        <AppBar
  position="fixed"
  sx={{
    backgroundColor: 'white',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1300,
  }}
>
<Container maxWidth="lg">
<Toolbar>
      {/* Logo Section */}
<Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          alignItems: 'center',
        }}
>
<Link to="/droneshalaa" style={{ textDecoration: 'none' }}>

            <img
              src={require('../../assets/image/png/Drone Shala.png')}
              alt="Droneshala Logo"
              style={{
                height: '40px',
                width: 'auto',
                transition: 'transform 0.3s ease',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
              onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            />
            </Link>
</Box>
 
      {/* Mobile Menu Icon */}
<IconButton
        edge="end"
        color="inherit"
        aria-label="menu"
        sx={{
          display: { xs: 'block', md: 'none' },
          color: 'black',
        }}
        onClick={handleDrawerToggle}
>
<MenuIcon sx={{ fontSize: '30px' }} />
</IconButton>
 
      {/* Desktop Navigation Links */}
<Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          gap: 4,
          flexGrow: 2,
          justifyContent: 'center',
          alignItems: 'center',
        }}
>
<Link to="/droneshalaa" style={{ textDecoration: 'none' }}>
            <Button
              sx={{
                color: 'black',
                fontWeight: '600',
                textTransform: 'none',
                fontSize: '16px',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.05)',
                },
              }}
            >
              Home 
            </Button>
            </Link>
<Link to="/E-library" style={{ textDecoration: 'none' }}>
<Button
          sx={{
            color: 'black',
            fontWeight: '600',
            textTransform: 'none',
            fontSize: '16px',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.05)',
            },
          }}
>
          E-Library 
</Button>
</Link>
<Link to="/training-courses/0" style={{ textDecoration: 'none' }}>
<Button
            sx={{
              color: 'black',
              fontWeight: '600',
              textTransform: 'none',
              fontSize: '16px',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.05)',
              },
            }}
>
            Courses
</Button>
</Link>
</Box>
 
      {/* Desktop Login and Get Started */}
<Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          gap: 2,
          alignItems: 'center',
        }}
>
<Button
          sx={{
            color: 'black',
            fontWeight: '600',
            textTransform: 'none',
            fontSize: '16px',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.05)',
            },
          }}
>
          Login
</Button>
<Button
          variant="contained"
          color="primary"
          sx={{
            color: 'white',
            fontWeight: '600',
            textTransform: 'none',
            fontSize: '16px',
            padding: '8px 20px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            '&:hover': {
              backgroundColor: 'primary.dark',
              boxShadow: '0 6px 8px rgba(0, 0, 0, 0.15)',
            },
          }}
>
          Get Started
</Button>
</Box>
</Toolbar>
</Container>
</AppBar>

        {/* Image Section */}
        <Box
  sx={{
    marginTop: '15px',
    width: '100%',
    height: '490px',
    backgroundImage: `url(${require('../../assets/image/png/freepik__the-style-is-candid-image-photography-with-natural__58623.jpg')})`, // Correct way to use the require statement
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingLeft: { xs: '20px', md: '80px' }, // Responsive padding
    position: 'relative',
    overflow: 'hidden',
  }}
>
<Box sx={{ maxWidth: '600px', zIndex: 1 }}>
<Typography
      variant="h2"
      sx={{
        color: 'white',
        fontWeight: 'bold',
        fontSize: { xs: '2rem', md: '3rem' }, // Responsive font size
        lineHeight: 1.2,
        mb: 2, // Margin bottom for spacing
      }}
>
      Welcome to DroneShala
</Typography>
<Typography
      variant="h6"
      sx={{
        color: 'rgba(255, 255, 255, 0.8)',
        fontWeight: 'normal',
        mb: 3, // Margin bottom for spacing
      }}
>
      Explore the world of drones with our expert-led courses and cutting-edge technology.
</Typography>
<Button
      variant="contained"
      sx={{
        backgroundColor: '#FF5722', // A vibrant color for the button
        color: 'white',
        fontWeight: 'bold',
        padding: '10px 30px',
        '&:hover': {
          backgroundColor: '#E64A19', // Darker shade on hover
        },
      }}
>
      Get Started
</Button>
</Box>
</Box>
{/* New Section (below the first Box) */}
<Box sx={{
  padding: '60px 20px',
  backgroundImage: 'url(https://www.transparenttextures.com/patterns/soft-leather.png), linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(220, 220, 220, 0.6))',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  borderRadius: '15px',
  boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)',
  backdropFilter: 'blur(8px)',
  transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
  maxWidth: 'auto'
}}>

  {/* Heading */}
  <Typography variant="h2" sx={{
    textAlign: 'center',
    fontWeight: '800',
    marginBottom: '30px',
    color: '#2C3E50',
    fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
    letterSpacing: '-0.05em',
  }}>
    Explore Our Courses
  </Typography>

  {/* Paragraph */}
  <Typography variant="body1" sx={{
    textAlign: 'center',
    marginBottom: '50px',
    color: '#555',
    fontSize: '1.1rem',
    lineHeight: '1.8',
    maxWidth: '800px',
    mx: 'auto',
    px: { xs: '20px', sm: '0' },
  }}>
    Our courses are designed to provide you with the skills and knowledge necessary to succeed in the exciting field of drone technology.
    Whether you're a beginner or an expert, we have the right course for you.
  </Typography>

  {/* Cards Section */}
  <Grid container spacing={4} justifyContent="flex-start" sx={{ display: 'flex', flexWrap: 'wrap', ml: '-1%' }}>
    {/* Card 1 */}
    <Grid item xs={12} sm={6} md={4}>
      <Card sx={{
        maxWidth: 345,
        borderRadius: '15px',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column', // Stack content vertically
        height: '100%', // Ensure the card takes full height
        transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
        '&:hover': {
          transform: 'translateY(-10px)',
          boxShadow: '0 12px 24px rgba(0, 0, 0, 0.2)',
        }
      }}>
        <CardMedia
          component="img"
          alt="Course Image"
          height="200"
          src={require('../../assets/image/png/freepik__the-style-is-candid-image-photography-with-natural__58624.jpg')}
          sx={{ transition: 'transform 0.3s ease-in-out', '&:hover': { transform: 'scale(1.1)' } }}
        />
        <CardContent sx={{
          textAlign: 'center',
          padding: '20px',
          flexGrow: 1, // Allow content to fill available space
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between' // Ensure content stays evenly spaced
        }}>
          <Typography variant="h5" sx={{
            fontWeight: '700',
            color: '#2C3E50',
            mb: '10px'
          }}>
            Drone Pilot Course
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{
            mb: '20px',
            fontSize: '0.95rem'
          }}>
            Learn the basics of flying drones and how to operate them for professional use.
          </Typography>
          <Button variant="contained" color="primary" sx={{
            width: '100%',
            fontWeight: '600',
            padding: '10px 20px',
            borderRadius: '8px',
            backgroundColor: '#3498DB',
            '&:hover': {
              backgroundColor: '#2980B9',
            }
          }}>
            Learn More
          </Button>
        </CardContent>
      </Card>
    </Grid>

    {/* Card 2 */}
    <Grid item xs={12} sm={6} md={4}>
      <Card sx={{
        maxWidth: 345,
        borderRadius: '15px',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
        '&:hover': {
          transform: 'translateY(-10px)',
          boxShadow: '0 12px 24px rgba(0, 0, 0, 0.2)',
        }
      }}>
        <CardMedia
          component="img"
          alt="Course Image"
          height="200"
          src={require('../../assets/image/png/freepik__the-style-is-candid-image-photography-with-natural__58625.jpg')}
          sx={{ transition: 'transform 0.3s ease-in-out', '&:hover': { transform: 'scale(1.1)' } }}
        />
        <CardContent sx={{
          textAlign: 'center',
          padding: '20px',
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}>
          <Typography variant="h5" sx={{
            fontWeight: '700',
            color: '#2C3E50',
            mb: '10px'
          }}>
            Drone Maintenance Course
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{
            mb: '20px',
            fontSize: '0.95rem'
          }}>
            Master the skills required for drone maintenance, repairs, and troubleshooting.
          </Typography>
          <Button variant="contained" color="primary" sx={{
            width: '100%',
            fontWeight: '600',
            padding: '10px 20px',
            borderRadius: '8px',
            backgroundColor: '#3498DB',
            '&:hover': {
              backgroundColor: '#2980B9',
            }
          }}>
            Learn More
          </Button>
        </CardContent>
      </Card>
    </Grid>

    {/* Card 3 */}
    <Grid item xs={12} sm={6} md={4}>
      <Card sx={{
        maxWidth: 345,
        borderRadius: '15px',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
        '&:hover': {
          transform: 'translateY(-10px)',
          boxShadow: '0 12px 24px rgba(0, 0, 0, 0.2)',
        }
      }}>
        <CardMedia
          component="img"
          alt="Course Image"
          height="200"
          src={require('../../assets/image/png/freepik__the-style-is-candid-image-photography-with-natural__58626.jpg')}
          sx={{ transition: 'transform 0.3s ease-in-out', '&:hover': { transform: 'scale(1.1)' } }}
        />
        <CardContent sx={{
          textAlign: 'center',
          padding: '20px',
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}>
          <Typography variant="h5" sx={{
            fontWeight: '700',
            color: '#2C3E50',
            mb: '10px'
          }}>
            Advanced Drone Photography
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{
            mb: '20px',
            fontSize: '0.95rem'
          }}>
            Learn how to capture stunning aerial photographs and videos using drones.
          </Typography>
          <Button variant="contained" color="primary" sx={{
            width: '100%',
            fontWeight: '600',
            padding: '10px 20px',
            borderRadius: '8px',
            backgroundColor: '#3498DB',
            '&:hover': {
              backgroundColor: '#2980B9',
            }
          }}>
            Learn More
          </Button>
        </CardContent>
      </Card>
    </Grid>
  </Grid>
</Box>




<Box
  sx={{
    padding: '60px 20px',
    backgroundImage:
      'url(https://www.transparenttextures.com/patterns/soft-leather.png), linear-gradient(135deg, rgba(255, 255, 255, 0.8), rgba(220, 220, 220, 0.4))',
  }}
>
  {/* Image and Content (Left Image and Right Content) */}
<Grid
    container
    spacing={4}
    sx={{ marginBottom: '40px' }}
    alignItems="center"
>
<Grid item xs={12} sm={6}>
<Box
        sx={{
          position: 'relative',
          overflow: 'hidden',
          borderRadius: '10px',
          boxShadow: '0 10px 20px rgba(0, 0, 0, 0.5)',
          transition: 'transform 0.3s, box-shadow 0.3s',
          '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: '0 15px 30px rgba(0, 0, 0, 0.7)',
          },
        }}
>
<img
                src={require('../../assets/image/png/freepik__the-style-is-candid-image-photography-with-natural__58624.jpg')}
                alt="Fjords"
          width="100%"
          style={{
            maxHeight: '300px',
            objectFit: 'cover',
            display: 'block',
          }}
        />
<Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              'linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.6))',
          }}
        />
</Box>
</Grid>
<Grid item xs={12} sm={6}>
<Typography
        variant="h4"
        sx={{
          fontWeight: 'bold',
          marginBottom: '20px',
          color: 'primary.main',
        }}
>
        Drone Pilot Course
</Typography>
<Typography variant="body1" sx={{ lineHeight: 1.6, color: 'text.secondary' }}>
        Learn the basics of flying drones and how to operate them for professional use. This course will provide you with the fundamental skills required to start your career as a drone pilot.
</Typography>
<Button
        variant="contained"
        sx={{
          marginTop: '20px',
          padding: '10px 30px',
          fontWeight: 'bold',
          borderRadius: '25px',
          transition: 'transform 0.3s',
          '&:hover': {
            transform: 'scale(1.05)',
          },
        }}
>
        Learn More
</Button>
</Grid>
</Grid>
 
  {/* Image and Content (Right Image and Left Content) */}
<Grid
    container
    spacing={4}
    sx={{ marginBottom: '40px' }}
    alignItems="center"
    flexDirection={{ xs: 'column-reverse', sm: 'row-reverse' }}
>
<Grid item xs={12} sm={6}>
<Box
        sx={{
          position: 'relative',
          overflow: 'hidden',
          borderRadius: '10px',
          boxShadow: '0 10px 20px rgba(0, 0, 0, 0.5)',
          transition: 'transform 0.3s, box-shadow 0.3s',
          '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: '0 15px 30px rgba(0, 0, 0, 0.7)',
          },
        }}
>
<img
                    src={require('../../assets/image/png/freepik__the-style-is-candid-image-photography-with-natural__58625.jpg')}
                    alt="Drone Maintenance Course"
          width="100%"
          style={{
            maxHeight: '300px',
            objectFit: 'cover',
            display: 'block',
          }}
        />
<Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              'linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.6))',
          }}
        />
</Box>
</Grid>
<Grid item xs={12} sm={6}>
<Typography
        variant="h4"
        sx={{
          fontWeight: 'bold',
          marginBottom: '20px',
          color: 'primary.main',
        }}
>
        Drone Maintenance Course
</Typography>
<Typography variant="body1" sx={{ lineHeight: 1.6, color: 'text.secondary' }}>
        Master the skills required for drone maintenance, repairs, and troubleshooting. Learn how to keep your drone in top condition and perform basic repairs.
</Typography>
<Button
        variant="contained"
        sx={{
          marginTop: '20px',
          padding: '10px 30px',
          fontWeight: 'bold',
          borderRadius: '25px',
          transition: 'transform 0.3s',
          '&:hover': {
            transform: 'scale(1.05)',
          },
        }}
>
        Learn More
</Button>
</Grid>
</Grid>
</Box>

{/* Add this in the CSS or in the sx prop for 3D effect */}
<style jsx>
  {`
    .card-image {
      perspective: 1000px;  // Set perspective for 3D effect
    }
    
    .card-image:hover {
      transform: rotateY(15deg) rotateX(5deg); // Apply 3D rotation on hover
      box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);  // Deeper shadow for the 3D illusion
    }
  `}
</style>



{/* CSS for 3D Effect */}
<style jsx>
{`
  .card-image {
    perspective: 1000px;  // Set perspective for 3D effect
  }

  .card-image:hover {
    transform: rotateY(15deg) rotateX(5deg) scale(1.05); // 3D rotation on hover, scale slightly
    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.3);  // Deeper shadow for the 3D illusion
  }
`}
</style>


<Box sx={{ padding: '60px 20px', textAlign: 'center', marginX: 'auto', maxWidth: '1200px' }}>
  {/* Section Heading and Paragraph */}
  <Typography variant="h4" sx={{ marginBottom: '20px', fontWeight: 'bold', color: 'primary.main' }}>
    Our Featured Courses
  </Typography>
  <Typography variant="h6" sx={{ marginBottom: '40px', maxWidth: '800px', margin: '0 auto', color: 'text.secondary' }}>
    Explore our selection of expertly designed courses that will help you master drone flying, maintenance, and more!
  </Typography>

  {/* Cards Section */}
  <Grid container spacing={4} justifyContent="center">
    {/* Card 1 */}
    <Grid item xs={12} sm={6} md={3}>
      <Card
        sx={{
          backgroundColor: '#f0f0f0',
          borderRadius: '10px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          transition: 'transform 0.3s, box-shadow 0.3s',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          backgroundImage: 'url(https://your-image-url-for-photography-course.com)', // Add the background image URL here
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
          },
        }}
      >
        <CardContent sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, alignItems: 'center' }}>
          <Star sx={{ fontSize: 50, color: '#ff9800' }} />
          <Typography variant="h5" sx={{ marginTop: '20px', fontWeight: 'bold', color: 'text.primary' }}>
            Drone Photography
          </Typography>
          <Typography variant="body2" sx={{ marginTop: '10px', color: 'text.secondary' }}>
            Learn how to capture stunning aerial shots and videos using drones. Master the art of drone photography.
          </Typography>
        </CardContent>
        <CardActions sx={{ justifyContent: 'center', paddingBottom: '20px' }}>
          <Button
            variant="contained"
            color="primary"
            sx={{
              borderRadius: '25px',
              padding: '10px 30px',
              fontWeight: 'bold',
              transition: 'transform 0.3s',
              '&:hover': {
                transform: 'scale(1.03)',
              },
            }}
          >
            Learn More
          </Button>
        </CardActions>
      </Card>
    </Grid>

    {/* Card 2 */}
    <Grid item xs={12} sm={6} md={3}>
      <Card
        sx={{
          backgroundColor: '#e3f2fd',
          borderRadius: '10px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          transition: 'transform 0.3s, box-shadow 0.3s',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          backgroundImage: 'url(https://your-image-url-for-maintenance-course.com)', // Add the background image URL here
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
          },
        }}
      >
        <CardContent sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, alignItems: 'center' }}>
          <Build sx={{ fontSize: 50, color: '#2196f3' }} />
          <Typography variant="h5" sx={{ marginTop: '20px', fontWeight: 'bold', color: 'text.primary' }}>
            Drone Maintenance
          </Typography>
          <Typography variant="body2" sx={{ marginTop: '10px', color: 'text.secondary' }}>
            Learn to maintain, repair, and troubleshoot drones effectively. Keep your drones in top shape!
          </Typography>
        </CardContent>
        <CardActions sx={{ justifyContent: 'center', paddingBottom: '20px' }}>
          <Button
            variant="contained"
            color="primary"
            sx={{
              borderRadius: '25px',
              padding: '10px 30px',
              fontWeight: 'bold',
              transition: 'transform 0.3s',
              '&:hover': {
                transform: 'scale(1.03)',
              },
            }}
          >
            Learn More
          </Button>
        </CardActions>
      </Card>
    </Grid>

    {/* Card 3 */}
    <Grid item xs={12} sm={6} md={3}>
      <Card
        sx={{
          backgroundColor: '#e8f5e9',
          borderRadius: '10px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          transition: 'transform 0.3s, box-shadow 0.3s',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          backgroundImage: 'url(https://your-image-url-for-flight-training-course.com)', // Add the background image URL here
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
          },
        }}
      >
        <CardContent sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, alignItems: 'center' }}>
          <Flight sx={{ fontSize: 50, color: '#4caf50' }} />
          <Typography variant="h5" sx={{ marginTop: '20px', fontWeight: 'bold', color: 'text.primary' }}>
            Drone Flight Training
          </Typography>
          <Typography variant="body2" sx={{ marginTop: '10px', color: 'text.secondary' }}>
            Get hands-on training to become an expert drone pilot. Learn to navigate drones with ease and confidence.
          </Typography>
        </CardContent>
        <CardActions sx={{ justifyContent: 'center', paddingBottom: '20px' }}>
          <Button
            variant="contained"
            color="primary"
            sx={{
              borderRadius: '25px',
              padding: '10px 30px',
              fontWeight: 'bold',
              transition: 'transform 0.3s',
              '&:hover': {
                transform: 'scale(1.03)',
              },
            }}
          >
            Learn More
          </Button>
        </CardActions>
      </Card>
    </Grid>

    {/* Card 4 */}
    <Grid item xs={12} sm={6} md={3}>
      <Card
        sx={{
          backgroundColor: '#fff3e0',
          borderRadius: '10px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          transition: 'transform 0.3s, box-shadow 0.3s',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          backgroundImage: 'url(https://your-image-url-for-safety-course.com)', // Add the background image URL here
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
          },
        }}
      >
        <CardContent sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, alignItems: 'center' }}>
          <School sx={{ fontSize: 50, color: '#ff5722' }} />
          <Typography variant="h5" sx={{ marginTop: '20px', fontWeight: 'bold', color: 'text.primary' }}>
            Drone Safety
          </Typography>
          <Typography variant="body2" sx={{ marginTop: '10px', color: 'text.secondary' }}>
            Learn the critical safety measures and best practices for flying drones responsibly and legally.
          </Typography>
        </CardContent>
        <CardActions sx={{ justifyContent: 'center', paddingBottom: '20px' }}>
          <Button
            variant="contained"
            color="primary"
            sx={{
              borderRadius: '25px',
              padding: '10px 30px',
              fontWeight: 'bold',
              transition: 'transform 0.3s',
              '&:hover': {
                transform: 'scale(1.03)',
              },
            }}
          >
            Learn More
          </Button>
        </CardActions>
      </Card>
    </Grid>
  </Grid>
</Box>

{/* < DroneshalaVendorForm /> */}

   

<div
  style={{
    backgroundImage:
      'url(https://www.transparenttextures.com/patterns/soft-leather.png), linear-gradient(135deg, rgba(255, 255, 255, 0.8), rgba(220, 220, 220, 0.4))',
    padding: '60px 20px',
  }}
>
  {/* Centered Heading and Paragraph */}
<Box sx={{ textAlign: 'center', marginBottom: '60px' }}>
<Typography variant="h4" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
      Welcome to Droneshala
</Typography>
<Typography variant="body1" sx={{ marginTop: '20px', color: 'text.secondary', maxWidth: '800px', margin: '0 auto' }}>
      Explore a variety of courses and resources to enhance your knowledge of drones and aerial technology.
</Typography>
</Box>
 
  {/* Cards Section */}
<Grid container spacing={4} justifyContent="center">
    {/* Card 1 */}
<Grid item xs={12} md={6}>
<Card
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: '250px',
          backgroundImage: 'url(https://www.w3schools.com/w3images/fjords.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderRadius: '10px',
          position: 'relative',
          overflow: 'hidden',
          transition: 'transform 0.3s, box-shadow 0.3s',
          
        }}
>
<Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.6))',
          }}
        />
<IconButton sx={{ fontSize: '50px', margin: '20px', color: 'white', zIndex: 1 }}>
<HomeIcon />
</IconButton>
<CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', zIndex: 1 }}>
<Typography variant="h6" sx={{ fontWeight: 'bold', color: 'white' }}>
            Home Course
</Typography>
<Typography variant="body2" sx={{ marginTop: '10px', color: 'white' }}>
            A comprehensive introduction to drone technology for beginners.
</Typography>
</CardContent>
</Card>
</Grid>
 
    {/* Card 2 */}
<Grid item xs={12} md={6}>
<Card
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: '250px',
          backgroundImage: 'url(https://www.w3schools.com/w3images/forest.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderRadius: '10px',
          position: 'relative',
          overflow: 'hidden',
          transition: 'transform 0.3s, box-shadow 0.3s',
         
        }}
>
<Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.6))',
          }}
        />
<IconButton sx={{ fontSize: '50px', margin: '20px', color: 'white', zIndex: 1 }}>
<SettingsIcon />
</IconButton>
<CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', zIndex: 1 }}>
<Typography variant="h6" sx={{ fontWeight: 'bold', color: 'white' }}>
            Advanced Settings
</Typography>
<Typography variant="body2" sx={{ marginTop: '10px', color: 'white' }}>
            Learn how to configure drones and adjust settings for various flight conditions.
</Typography>
</CardContent>
</Card>
</Grid>
 
    {/* Card 3 */}
<Grid item xs={12} md={6}>
<Card
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: '250px',
          backgroundImage: 'url(https://www.w3schools.com/w3images/mountains.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderRadius: '10px',
          position: 'relative',
          overflow: 'hidden',
          transition: 'transform 0.3s, box-shadow 0.3s',
          
        }}
>
<Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.6))',
          }}
        />
<IconButton sx={{ fontSize: '50px', margin: '20px', color: 'white', zIndex: 1 }}>
<CloudIcon />
</IconButton>
<CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', zIndex: 1 }}>
<Typography variant="h6" sx={{ fontWeight: 'bold', color: 'white' }}>
            Cloud Integration
</Typography>
<Typography variant="body2" sx={{ marginTop: '10px', color: 'white' }}>
            Dive into cloud-based drone data processing and real-time syncing.
</Typography>
</CardContent>
</Card>
</Grid>
 
    {/* Card 4 */}
<Grid item xs={12} md={6}>
<Card
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: '250px',
          backgroundImage: 'url(https://www.w3schools.com/w3images/photographer.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderRadius: '10px',
          position: 'relative',
          overflow: 'hidden',
          transition: 'transform 0.3s, box-shadow 0.3s',
          
        }}
>
<Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.6))',
          }}
        />
<IconButton sx={{ fontSize: '50px', margin: '20px', color: 'white', zIndex: 1 }}>
<BusinessIcon />
</IconButton>
<CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', zIndex: 1 }}>
<Typography variant="h6" sx={{ fontWeight: 'bold', color: 'white' }}>
            Business Applications
</Typography>
<Typography variant="body2" sx={{ marginTop: '10px', color: 'white' }}>
            Explore the potential of drones in industries like agriculture, delivery, and surveying.
</Typography>
</CardContent>
</Card>
</Grid>
</Grid>
</div>
        {/* Mobile Drawer */}
        <Drawer
          anchor="right"
          open={drawerOpen}
          onClose={handleDrawerToggle}
          sx={{
            '& .MuiDrawer-paper': {
              width: '250px',
              paddingTop: '20px',
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              position: 'absolute',
              top: '64px',
              zIndex: 1200,
            },
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', padding: '20px' }}>
            {/* Drawer Menu Options */}
            <Button sx={{ color: 'black' }} onClick={handleDrawerToggle}>Home</Button>
            <Button sx={{ color: 'black' }} onClick={handleDrawerToggle}>About</Button>
            <Button sx={{ color: 'black' }} onClick={handleDrawerToggle}>Contact</Button>
            <Button sx={{ color: 'black' }} onClick={handleDrawerToggle}>Services</Button>
            <Button sx={{ color: 'black' }} onClick={handleDrawerToggle}>Testimonials</Button>
            <Button sx={{ color: 'black' }} onClick={handleDrawerToggle}>Login</Button>
            <Button
              variant="contained"
              color="primary"
              sx={{ color: 'white' }}
              onClick={handleDrawerToggle}
            >
              Get Started
            </Button>
          </Box>
        </Drawer>

        <Dialog
  open={openCourseRecommendation}
  onClose={handleDialogClose}
  sx={{
    '& .MuiDialog-paper': {
      width: '90%',           // Full width, adjustable
      height: '100vh',        // Full height of the screen
      maxWidth: 'none',       // No max-width limit
      margin: 0,              // No margin around the dialog
      padding: 0,             // No padding inside the dialog
      display: 'flex',
      flexDirection: 'column', // Allows vertical alignment of content
      borderRadius: '16px',   // Rounded corners
      overflow: 'hidden',     // Prevent overflow outside of the dialog
      position: 'relative',   // So we can position the close button relative to the dialog
    },
  }}
>
  <DialogContent
    sx={{
      padding: 0,                // Remove padding from DialogContent
      display: 'flex',
      flexDirection: 'column',   // Ensure content is laid out vertically
      justifyContent: 'center',  // Center content vertically
      alignItems: 'center',      // Center content horizontally
      height: '100%',            // Ensure content fills the entire height of the dialog
      overflowY: 'hidden',       // Disable vertical scrolling
    }}
  >
    {/* Close Button */}
    <IconButton
      onClick={handleDialogClose} // Close the dialog when clicked
      sx={{
        position: 'absolute',      // Position absolutely at the top right corner
        top: '16px',               // Add a little space from the top
        right: '16px',             // Add a little space from the right edge
        zIndex: 1,                 // Make sure it stays on top of other content
      }}
    >
      <CloseIcon />
    </IconButton>

    <Box sx={{ width: '100%' }}>
      <CourseRecommendation />
    </Box>
  </DialogContent>
</Dialog>



      </div>
      {/* <Footer /> */}
    </>
  );
};

export default Droneshala;
 